import { useGetProjectProjectFeaturesExist } from '@/service-library/hooks/project-project-features'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'

export default function useProjectFeatureEnabled(featureCode: string) {
  const { project } = useProjectContext()

  const { exists, isPending: isPendingProjectFeatures } =
    useGetProjectProjectFeaturesExist({
      filters: {
        project_id: project.id,
        project_feature__code: featureCode,
        limit: '1',
      },
    })

  return {
    isEnabled: exists,
    isPending: isPendingProjectFeatures,
  }
}
